import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Scroll to specific section
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }

    // Default → scroll to top
    window.scrollTo({
      top: 0,
      behavior: "auto", // better for navigation
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;